var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIMailbox = function SvgIMailbox(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 309,
    viewBox: "0 0 290 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.185 162.054V95.0233C105.185 59.9833 139.926 31.5869 182.796 31.5869H77.6114C34.7417 31.5869 0 59.996 0 95.0233V153.588C0 158.257 4.62912 162.054 10.3575 162.054H105.185Z",
    fill: "url(#paint0_linear_4228_69279)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.455 157.934V92.6741C104.455 58.9865 130.038 31.5869 161.493 31.5869C192.948 31.5869 218.531 58.9865 218.531 92.6741V157.934H104.455Z",
    fill: "url(#paint1_linear_4228_69279)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231.88 162.054H104.455V155.187H231.88C234.371 155.187 236.398 156.721 236.398 158.624C236.398 160.52 234.371 162.054 231.88 162.054Z",
    fill: "#DDE3E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.789 103.577C74.2239 103.577 78.6298 97.7416 78.6298 90.5437C78.6298 83.3458 74.2239 77.5107 68.789 77.5107C63.3541 77.5107 58.9482 83.3458 58.9482 90.5437C58.9482 97.7416 63.3541 103.577 68.789 103.577Z",
    fill: "#3AD98A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5782 90.5437C75.5782 95.5152 72.5407 99.539 68.7886 99.539C65.0365 99.539 61.999 95.5152 61.999 90.5437C61.999 85.5722 65.0365 81.5484 68.7886 81.5484C72.5407 81.5346 75.5782 85.5722 75.5782 90.5437Z",
    fill: "#32C37A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5412 103.577C77.9838 103.577 82.382 97.7399 82.382 90.5437C82.382 83.3474 77.9701 77.5107 72.5412 77.5107H68.7891C74.2317 77.5107 78.6298 83.3474 78.6298 90.5437C78.6298 97.7399 74.218 103.577 68.7891 103.577H72.5412Z",
    fill: "#32C37A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5938 0V90.5439C63.5938 94.348 65.9165 97.4243 68.789 97.4243C71.6615 97.4243 73.9843 94.348 73.9843 90.5439V5.61693C73.9843 2.5132 71.4691 0 68.3629 0H63.5938Z",
    fill: "#32C37A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7893 29.2932H26.3613L38.1675 14.6397L26.3613 0H68.7893V29.2932Z",
    fill: "#2BA166"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M270.936 119.418L139.268 148.156L119.465 57.59L251.145 28.8643L270.936 119.418Z",
    fill: "#DAE029"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M270.935 119.419L205.243 77.1575C197.206 71.9837 186.482 74.3254 181.341 82.3804L139.268 148.169L270.935 119.419Z",
    fill: "#FAFDAA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.465 57.5901L185.158 99.8512C193.194 105.025 203.918 102.683 209.059 94.6283L251.132 28.8398L119.465 57.5901Z",
    fill: "#F2F92F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.384 162.053H95.5215V309H124.384V162.053Z",
    fill: "url(#paint2_linear_4228_69279)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4228_69279",
    x1: 17.5095,
    y1: 96.3899,
    x2: 165.363,
    y2: 96.3899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F8FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4228_69279",
    x1: 104.207,
    y1: 148.619,
    x2: 222.759,
    y2: 74.6017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1446,
    stopColor: "#E0E3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4228_69279",
    x1: 109.953,
    y1: 162.053,
    x2: 109.953,
    y2: 309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE3E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE3E9",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIMailbox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/i-mailbox.3771913b917cfeada4771ab99df7e6e2.svg";